// @flow
import React, {PureComponent} from 'react'
import {toUpper} from 'lodash'
import I18n from 'I18n'
import {Link} from 'react-router-dom'
import styles from './NavSide.module.scss'

import {screenConstants} from '../constants'
import Modal from './Modal'
import {adminURL} from 'modules/Common/constants'

import type {DispatchProps} from '../containers/NavSideContainer'

export type Props = {
  location: {
    pathname: string
  },
  logout: $PropertyType<DispatchProps, 'logout'>
};

export type State = {
  isShowLogoutModal: boolean
};

const I18nLocal = I18n.admin

export class NavSide extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isShowLogoutModal: false
    }
  }
  handleOpenLogoutModal = () => {
    this.setState({
      isShowLogoutModal: true
    })
  }
  handleCloseLogoutModal = () => {
    this.setState({
      isShowLogoutModal: false
    })
  }
  render() {
    let screen = screenConstants.companies
    if (this.props.location.pathname.includes('/companies')) {
      screen = screenConstants.companies
    } else if (this.props.location.pathname.includes('/accountmanagers')) {
      screen = screenConstants.accountManagers
    } else if (this.props.location.pathname.includes('/clients')) {
      screen = screenConstants.clients
    }
    return (
      <div className={styles.container}>
        <Link to={adminURL.companies.index} className={`${styles['sub-header']} ${screen === screenConstants.companies ? styles.active : ''}`}>
          {I18nLocal.companies}
        </Link>
        <Link to={adminURL.accountManagers.index} className={`${styles['sub-header']} ${screen === screenConstants.accountManagers ? styles.active : ''}`}>
          {I18nLocal.accountManagers}
        </Link>
        <Link to={adminURL.clients.index} className={`${styles['sub-header']} ${screen === screenConstants.clients ? styles.active : ''}`}>
          Clients
        </Link>
        <div onClick={this.handleOpenLogoutModal} className={styles['sub-header']}>
          {I18nLocal.logout}
        </div>
        <LogOutConfirmModal handleClickButton={this.props.logout} handleClose={this.handleCloseLogoutModal} isShow={this.state.isShowLogoutModal} />
      </div>
    )
  }
}

export type LogOutConfirmModalProps = {
  isShow: boolean,
  handleClose: () => void,
  handleClickButton: Function
};

export class LogOutConfirmModal extends PureComponent<LogOutConfirmModalProps, void> {
  renderHeader = () => {}
  renderBody = () => {
    return (
      <div className={styles['success-form']}>
        <div className={styles['title']}>{toUpper(I18nLocal.logout)}</div>
        <span>{I18nLocal.logoutConfirm}</span>
        <div className={styles.buttons}>
          <div onClick={this.props.handleClose} className={`${styles.button} ${styles.gray}`}>
            {I18nLocal.cancel}
          </div>
          <div onClick={this.props.handleClickButton} className={styles.button}>
            {I18nLocal.logout}
          </div>
        </div>
      </div>
    )
  }
  afterOpen = () => {}
  render() {
    return (
      <Modal
        handleClose={this.props.handleClose}
        isShow={this.props.isShow}
        renderHeader={this.renderHeader}
        renderBody={this.renderBody}
        afterOpen={this.afterOpen}
      />
    )
  }
}

export default NavSide
